import {DipRegistrationContext} from './dip-registration-context.model';
import {DipRegistrationUAPState} from './uap/dip-registration-uap-state.model';

export class DipRegistrationAppContext {
  public forceReset: boolean;
  public phoneNumber: string;
  public language: string;
  public languageFromUrl: boolean;
  public context: DipRegistrationContext;
  public csrfToken: string;
  public csrfHeader: string;
  public environmentId: string;
  public skipSystemAvailability: boolean;
  public disableThirdPartyScripts: boolean;
  public skipMaintenanceMode: boolean;
  public wcmLoaded: boolean;
  public sessionId: string;
  public version: string;
  public tmxId: string;
  public dipssGuid: string;
  public isAutoEnrollFlow: boolean;

  public loadFromUAPState(uapState: DipRegistrationUAPState) {
    if (uapState) {
      this.skipMaintenanceMode = uapState.skipMaintenanceMode;
      this.skipSystemAvailability = uapState.skipSystemAvailability;
      this.skipMaintenanceMode = uapState.skipMaintenanceMode;
      this.disableThirdPartyScripts = uapState.disableThirdPartyScripts;
      if (uapState.language) {
        this.language = uapState.language;
        this.languageFromUrl = true;
      }
      this.environmentId = uapState.environmentId;
      this.dipssGuid = uapState.dipssGuid;
    }
  }

}






